export default function (state = {
	isOpen: false,
}) {
	return {
		isOpen: state.isOpen,

		init() {
			this.events()
		},

		events() {
			window.addEventListener('mini-cart:toggle', () => {
				this.toggle()
			})

			window.addEventListener('mini-cart:open', () => {
				this.open()
			})

			window.addEventListener('mini-cart:close', () => {
				this.close()
			})

			window.addEventListener('keyup', (event) => {
				if (event.key === 'Escape' && this.isOpen) {
					this.close()
				}
			})
		},

		toggle() {
			this.isOpen ? this.close() : this.open()
		},

		open() {
			if (this.isOpen) {
				return
			}

			this.isOpen = true

			document.body.classList.add('has-overlay')
		},

		close() {
			if (!this.isOpen) {
				return
			}

			this.isOpen = false

			document.body.classList.remove('has-overlay')
		},
	}
}
